import { render, staticRenderFns } from "./cgzpfirst.vue?vue&type=template&id=4fa445d2&scoped=true&"
import script from "./cgzpfirst.vue?vue&type=script&lang=js&"
export * from "./cgzpfirst.vue?vue&type=script&lang=js&"
import style0 from "./cgzpfirst.vue?vue&type=style&index=0&id=4fa445d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa445d2",
  null
  
)

export default component.exports